import React from "react";
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel";
import basilique from '../../../ASSETS/tourisme/Image/laBrise.png'
import mosque from '../../../ASSETS/tourisme/Image/image_suggestion/Mosque.png'
import cascade from '../../../ASSETS/tourisme/Image/image_suggestion/cascade_man.png'
import banco from '../../../ASSETS/tourisme/Image/laBrise.png'
import cathedrale from '../../../ASSETS/tourisme/Image/laBrise.png'
import fort from '../../../ASSETS/tourisme/Image/laBrise.png'
import "pure-react-carousel/dist/react-carousel.es.css";
import {Link} from 'react-router-dom'
import Restau from "../../../API/tourisme/restaurant/index";
import { useEffect, useState, useCallback } from "react";


/* Install pure-react-carousel using -> npm i pure-react-carousel */

export default function Index() {

  const [restaurants, setRestaurants] = useState([]);
  const getAllRestau = () => {
          Restau.getAllData()
          .then((res) => {
              //console.log('Response:',res.data);
              if (res.data.status === 200) {
                  setRestaurants(res.data.data)
              }
          })
          .catch((err) => {
              console.log(err);
          })
      }
  useEffect(() => {
          getAllRestau();
  }, []);
  
  const handleRedirect = (id) => {
    window.location.href = `/restaurants/Voir_Plus?id=${id}`;
  };

  return (
    <div className=" mx-auto bg-[#233D4D] mb-20">
      <div className="flex items-center justify-center w-full h-full px-4 py-24 sm:py-8">
        {/* Carousel for desktop and large size devices */}
        <CarouselProvider 
          className="hidden md:block" 
          naturalSlideWidth={100} 
          isIntrinsicHeight={true} 
          totalSlides={restaurants.length} 
          visibleSlides={4} 
          step={1} 
          infinite={true}
        >
          <div className="relative flex items-center justify-center w-full">
            <ButtonBack role="button" aria-label="slide backward" className="absolute left-0 z-30 ml-8 cursor-pointer focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="prev">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1L1 7L7 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="flex items-center justify-start h-full transition duration-700 ease-out lg:gap-8 md:gap-6 gap-14">
                  {restaurants.map((item, index)=>(
                    <Slide index={index} key={index}>
                      <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                        <img src={`data:image/png;base64,${item[0]}`} alt={item?.title_announce} className="object-cover object-center w-full" />
                        <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                          <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog {index + 1}</h2>
                          {/* <Link to=""> */}
                            <div onClick={() => handleRedirect(item.id_announce)} className="flex items-end h-full pb-6 cursor-pointer">
                              <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">{item?.title_announce}</h3>
                            </div>
                          {/* </Link> */}
                        </div>
                      </div>
                    </Slide>
                    
                  ))}
                  {/* <Slide index={1}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cascade} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 2</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La cascade de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={mosque} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 3</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La mosque de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={banco} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 4</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La forêt du banco</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cathedrale} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 5</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={fort} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 6</h2>
                        <Link>
                        <div className="flex items-end h-full pb-6">
                          <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">Le fort de Dabou</h3>
                        </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={0}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={basilique} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 1</h2>
                        <Link to="">
                          <div className="flex items-end h-full pb-6 ">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Basilique de Yamoussokro</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={1}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cascade} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 2</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La cascade de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={mosque} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 3</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La mosque de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={banco} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 4</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La forêt du banco</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cathedrale} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 5</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={fort} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 6</h2>
                        <Link>
                        <div className="flex items-end h-full pb-6">
                          <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">Le fort de Dabou</h3>
                        </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  */}
                  
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute right-0 z-30 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="next">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonNext>
          </div>
        </CarouselProvider>

        {/* Carousel for tablet and medium size devices */}
        <CarouselProvider 
          className="hidden md:hidden xs:block" 
          naturalSlideWidth={100} 
          isIntrinsicHeight={true} 
          totalSlides={restaurants.length} 
          visibleSlides={2} 
          step={1} 
          infinite={true}
        >
          <div className="relative flex items-center justify-center w-full">
            <ButtonBack role="button" aria-label="slide backward" className="absolute left-0 z-30 ml-8 cursor-pointer focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="prev">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1L1 7L7 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="flex items-center justify-start h-full transition duration-700 ease-out lg:gap-8 md:gap-6 gap-14">
                  {restaurants.map((item, index)=>(
                    <Slide index={index} key={index}>
                      <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                        <img src={`data:image/png;base64,${item[0]}`} alt={item?.title_announce} className="object-cover object-center w-full" />
                        <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                          <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog {index + 1}</h2>
                          {/* <Link to=""> */}
                            <div onClick={() => handleRedirect(item.id_announce)} className="flex items-end h-full pb-6 cursor-pointer">
                              <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">{item?.title_announce}</h3>
                            </div>
                          {/* </Link> */}
                        </div>
                      </div>
                    </Slide>

                  ))}
                  {/* <Slide index={1}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cascade} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 2</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La cascade de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={mosque} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 3</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La mosque de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={banco} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 4</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La forêt du banco</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cathedrale} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 5</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={fort} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 6</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">Le fort de Dabou</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>

                  <Slide index={0}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={basilique} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 1</h2>
                        <Link to="">
                          <div className="flex items-end h-full pb-6 ">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Basilique de Yamoussokro</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={1}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cascade} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 2</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La cascade de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={mosque} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 3</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La mosque de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={banco} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 4</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La forêt du banco</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cathedrale} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 5</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={fort} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 6</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">Le fort de Dabou</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide> */}
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute right-0 z-30 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="next">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonNext>
          </div>
        </CarouselProvider>

        {/* Carousel for mobile and Small size Devices */}
        <CarouselProvider 
          className="block xs:hidden " 
          naturalSlideWidth={100} 
          isIntrinsicHeight={true} 
          totalSlides={restaurants.length} 
          visibleSlides={1} 
          step={1} 
          infinite={true}
        >
          <div className="relative flex items-center justify-center w-full">
            <ButtonBack role="button" aria-label="slide backward" className="absolute left-0 z-30 ml-8 cursor-pointer focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="prev">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1L1 7L7 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="flex items-center justify-start w-full h-full transition duration-700 ease-out lg:gap-8 md:gap-6">
                    {restaurants.map((item, index)=>(
                      <Slide index={index} key={index}>
                        <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                          <img src={`data:image/png;base64,${item[0]}`} alt={item?.title_announce} className="object-cover object-center w-full" />
                          <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                            <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog {index+1}</h2>
                            {/* <Link to=""> */}
                              <div onClick={() => handleRedirect(item.id_announce)} className="flex items-end h-full pb-6 cursor-pointer">
                                <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">{item?.title_announce}</h3>
                              </div>
                            {/* </Link> */}
                          </div>
                        </div>
                      </Slide>
                      
                    ))}
                  {/* <Slide index={1}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cascade} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 2</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La cascade de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={mosque} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 3</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La mosque de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={banco} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 4</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La forêt du banco</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cathedrale} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 5</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={fort} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 6</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">Le fort de Dabou</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>

                  <Slide index={0}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={basilique} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 1</h2>
                        <Link to="">
                          <div className="flex items-end h-full pb-6 ">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Basilique de Yamoussokro</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={1}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cascade} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 2</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La cascade de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={mosque} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 3</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La mosque de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={banco} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 4</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La forêt du banco</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={cathedrale} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 5</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="relative flex flex-shrink-0 w-full sm:w-auto">
                      <img src={fort} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="absolute w-full h-full p-6 bg-gray-800 bg-opacity-30">
                        <h2 className="text-base leading-4 text-white lg:text-xl lg:leading-5">Catalog 6</h2>
                        <Link>
                          <div className="flex items-end h-full pb-6">
                            <h3 className="text-lg font-semibold leading-5 text-white lg:text-2xl lg:leading-6">Le fort de Dabou</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide> */}
                  
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute right-0 z-30 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="next">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonNext>
          </div>
        </CarouselProvider>
      </div>

      

    </div>
  );
}
